import ScrollLocker from "./ScrollLocker";
import gsap from "gsap";
import Cookies from "js-cookie";
import ModalController from "./ModalController";

export default class AgeGateController {
    constructor() {
        this.popupWrapper = document.querySelector('.js-age-gate-wrapper');
        this.noButton = document.querySelector('.js-no-button');
        this.yesButton = document.querySelector('.js-yes-button');
        this.modalController = new ModalController();

        this.scrollLock = new ScrollLocker();

        if (this.popupWrapper && !Cookies.get('ageGatePassed')) {
            this.init();
        }
    }

    init() {
        this.yesButton.addEventListener('click', () => {
            this.hidePopup();
            this.modalController.showPopup();
        });

        this.noButton.addEventListener('click', () => {
            this.noButton.style.display = "none";
            this.yesButton.style.display = "none";
            document.querySelector('.c-age-gate__title').style.display = "none";
            document.querySelector('.c-age-gate__no-text').style.display = "block";
        });

        this.showPopup();
    }

    showPopup() {
        gsap.to(this.popupWrapper, .3, {
            autoAlpha: 1
        });
        this.scrollLock.lockScroll();
    }

    hidePopup() {

        Cookies.set('ageGatePassed', true, {
            expires: 365
        });

        gsap.to(this.popupWrapper, .3, {
            autoAlpha: 0,
            onComplete: () => {
                this.modalController.showPopup();
            }
        });
        this.scrollLock.unlockScroll();
    }

}
